module.exports = __webpack_public_path__ + "assets/img/7fdbe51a085b082220b1d467c663bdb0.svg";